// extracted by mini-css-extract-plugin
module.exports = {"UpgradeNoticeBox":"UpgradeNoticeAlert_UpgradeNoticeBox__1gP6n"};